export default "__VITE_ASSET__7f954157__"